import clsx from 'clsx'
import styles from './styles.module.scss'
import { ICardProps } from './types'

const generateCommonProps = ({
  id,
  size = 'md',
  className,
  disabled,
  hasHover = false,
  style,
}: ICardProps): {
  id: string
  className: string
  style: React.CSSProperties
} => {
  return {
    id: id || ' ',
    className: clsx('mui-card', 'drop-shadow-large-down-10', styles.card, styles[size], className, {
      [styles.disabled]: disabled,
      [styles.hasHover]: hasHover,
    }),
    style: { ...style },
  }
}

export default generateCommonProps
